<ng-template #positionDate>
  <div class="flex flex-col md:flex-row md:gap-3">
    <tandem-form-input
      class="w-full lg:max-w-xs"
      [form]="fpForm"
      [controlName]="'positionDate'"
      [inputType]="'date'"
      [inputId]="'positionDate'"
      [label]="'Position Date'"
      [placeholder]="'Position Date'"></tandem-form-input>
  </div>

</ng-template>

<div class="w-full flex flex-col items-center py-10 md:py-20">
  <ng-container #assets *ngIf="currentPageNumber == 1">
    <form class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-6xl">
      <div class="w-full max-sm:hidden">
        <div class="flex flex-row items-center">
          <div class="flex flex-col gap-y-3 w-full">
            <h1 class="text-4xl">Assets</h1>
            <h2 class="text-2xl">{{ getHoverHintForPage() }}</h2>
          </div>
          <div class="flex flex-col gap-y-3 items-end">
            <h1 class="text-xl text-primary whitespace-nowrap">1 of 3: Assets</h1>
            <div class="flex flex-row gap-4 max-sm:hidden">
              <tandem-button  [onClick]="setPage.bind(this, currentPageNumber - 1)" color="white">Back</tandem-button>
              <tandem-button theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)" color="primary">Next</tandem-button>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full sm:hidden">
        <div class="flex flex-col gap-y-3">
          <h1 class="text-2xl text-primary">1 of 3: Assets</h1>
          <h2 class="text-xl">{{ getHoverHintForPage() }}</h2>
        </div>
      </div>
      <tandem-asset-table class="w-full" *ngFor="let category of financialPosition.assets" [assetCategory]="category" (changesMade)="recalculateTotals()" [mode]="mode" [details]="financialPosition.assetDetails"></tandem-asset-table>
      <div class="w-full">
        <div class="flex flex-col gap-y-3 sm:flex-row justify-between items-center">
          <span class="text-2xl font-semibold sm:order-2">Total Assets: {{financialPosition.totalAssets | currency}}</span>
          <tandem-button class="sm:order-3 w-full sm:w-fit" theme="solid" [onClick]="setPage.bind(this, 2)">Next: Liabilities</tandem-button>
          <tandem-button class="sm:order-1 w-full sm:w-fit" color="white" [onClick]="onSubmit.bind(this)" [type]="'submit'">Save and Exit</tandem-button>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container #liabilities *ngIf="currentPageNumber == 2">
    <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-6xl">
      <div class="w-full max-sm:hidden">
        <div class="flex flex-row items-center">
          <div class="flex flex-col gap-y-3 w-full">
            <h1 class="text-4xl">Liabilities</h1>
            <h2 class="text-2xl">{{ getHoverHintForPage() }}</h2>
          </div>
          <div class="flex flex-col gap-y-3 items-end">
            <h1 class="text-xl text-primary whitespace-nowrap">2 of 3: Liabilities</h1>
            <div class="flex flex-row gap-4 max-sm:hidden">
              <tandem-button  [onClick]="setPage.bind(this, currentPageNumber - 1)" color="white">Back</tandem-button>
              <tandem-button theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)" color="primary">Next</tandem-button>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full sm:hidden">
        <div class="flex flex-col gap-y-3">
          <h1 class="text-2xl text-primary">2 of 3: Liabilities</h1>
          <h2 class="text-xl">{{ getHoverHintForPage() }}</h2>
          <!--          <div class="flex w-full justify-end gap-x-4">-->
          <!--            <tandem-button  [onClick]="setPage.bind(this, currentPageNumber - 1)" color="white">Back</tandem-button>-->
          <!--            <tandem-button theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)" color="primary">Next</tandem-button>-->
          <!--          </div>-->
        </div>
      </div>
      <tandem-liability-table class="w-full" *ngFor="let category of financialPosition.liabilities" [liabilityCategory]="category" (changesMade)="recalculateTotals()" [mode]="mode" [details]="financialPosition.liabilityDetails"></tandem-liability-table>
      <div class="w-full">
        <div class="flex flex-col gap-y-3 sm:flex-row justify-between items-center">
          <span class="text-xl font-semibold sm:order-2">Total Liabilities: {{financialPosition.totalLiabilities | currency}}</span>
          <tandem-button class="sm:order-3 w-full sm:w-fit" theme="solid" [onClick]="setPage.bind(this, 3)">Next: Summary</tandem-button>
          <tandem-button class="sm:order-1 w-full sm:w-fit" color="white" [onClick]="setPage.bind(this, 1)">Back: Assets</tandem-button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container #summary *ngIf="currentPageNumber == 3">
    <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-6xl mb-20">
      <div class="w-full max-sm:hidden">
        <div class="flex flex-row items-center">
          <div class="flex flex-col gap-y-3 w-full">
            <h1 class="text-4xl">Summary</h1>
            <h2 class="text-2xl">{{ getHoverHintForPage() }}</h2>
          </div>
          <div class="flex flex-col gap-y-3 items-end">
            <h1 class="text-xl text-primary whitespace-nowrap">3 of 3: Summary</h1>
          </div>
        </div>
      </div>
      <div class="w-full sm:hidden">
        <div class="flex flex-col gap-y-3">
          <h1 class="text-2xl text-primary">3 of 3: Summary</h1>
          <h2 class="text-xl">{{ getHoverHintForPage() }}</h2>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-7xl">
      <div class="flex flex-col md:flex-row w-full gap-5 justify-between">
        <div class="flex flex-col justify-between h-full">
          <div class="flex flex-col gap-8">
            <div class="flex flex-col gap-y-3">
              <h2 class="text-2xl font-bold">Assets</h2>
              <h5 class="text-lg">Total Assets: {{financialPosition.totalAssets | currency}}</h5>
              <h5 class="text-lg">Liquid Assets: {{financialPosition.liquidAssets | currency}}</h5>
              <h5 class="text-lg">Average Return: {{financialPosition.averageReturn | percent:'1.2-2'}}</h5>
            </div>
            <div class="flex flex-col gap-y-3">
              <h2 class="text-2xl font-bold">Liabilities</h2>
              <h5 class="text-lg">Total Liabilities: {{financialPosition.totalLiabilities | currency}}</h5>
              <h5 class="text-lg">Short-Term Liabilities: {{financialPosition.shortTermLiabilities | currency}}</h5>
              <h5 class="text-lg">Minimum Monthly Payment: {{financialPosition.totalMinimumPayment | currency}}</h5>
              <h5 class="text-lg">Average Interest Rate: {{financialPosition.averageInterestRate | percent:'1.2-2'}}</h5>
            </div>
          </div>
          <div class="flex flex-row justify-center gap-4 mt-8 max-md:hidden">
            <tandem-button color="white" [onClick]="setPage.bind(this, 2)">Back</tandem-button>
            <tandem-button color="primary" [onClick]="onSubmit.bind(this)">Submit</tandem-button>
          </div>
        </div>
        <tandem-financial-position-graph class="w-full" style="height: 60vh" [financialPosition]="financialPosition" [omitLegend]="true"></tandem-financial-position-graph>
        <div class="flex flex-col justify-center gap-4 md:hidden w-full">
          <tandem-button class="w-full" color="primary" [onClick]="onSubmit.bind(this)">Submit</tandem-button>
          <tandem-button class="w-full" color="white" [onClick]="setPage.bind(this, 2)">Back: Liabilities</tandem-button>
        </div>
      </div>
    </div>

  </ng-container>
</div>
